import $ from 'jquery';

export default function sortSelectDirective(context=document.body) {
	const $context = $(context);

	const pageUrl = $('link[rel=canonical]').attr('href')

	$context.find('[sw-select-autoloader]').on('change', function(e) {
		const selectField = $(this).find('select')[0];
		const searchParams = Object.fromEntries(new URLSearchParams(window.location.search));
		searchParams[selectField.name] = selectField.value;
		window.location.href = `${window.location.pathname}?${new URLSearchParams(searchParams).toString()}`;
	});
}



// WEBPACK FOOTER //
// ./source/scripts/directives/commerce/select-autoloader.js